export default "__VITE_ASSET__B9qqMiJ1__"